import { Injectable } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { ModalDataChangeEmail } from './modal-interfaces';
import { UserAccountSettingsModal2EmailComponent } from '@modules/user/components/user-account-settings-modal2-email/user-account-settings-modal2-email.component';
import { UserAccountSettingsModal2PasswordComponent } from '@modules/user/components/user-account-settings-modal2-password/user-account-settings-modal2-password.component';
import { UserAccountVerifyEmailModalComponent } from '@modules/user/components/user-account-verify-email-modal/user-account-verify-email-modal.component';
import { OverlayEventDetail } from '@ionic/core';

@Injectable({
    providedIn: 'root',
})
export class Modal2Service {
    constructor(private modalController: ModalController, private toastController: ToastController) {}

    async changeEmail(componentProps: ModalDataChangeEmail) {
        const modal = await this.modalController.create({
            component: UserAccountSettingsModal2EmailComponent,
            componentProps,
            cssClass: 'modal2-wrapper-450-450',
            backdropDismiss: true,
        });

        await modal.present();

        return await modal.onDidDismiss();
    }

    async updatePassword(componentProps: ModalDataChangeEmail) {
        const modal = await this.modalController.create({
            component: UserAccountSettingsModal2PasswordComponent,
            componentProps,
            cssClass: 'modal2-wrapper-450-600',
            backdropDismiss: true,
        });

        await modal.present();

        return await modal.onDidDismiss();
    }

    async openUserAccountVerifyEmail(componentProps: ModalDataChangeEmail) {
        const modal = await this.modalController.create({
            component: UserAccountVerifyEmailModalComponent,
            componentProps: {
                email: componentProps.currentEmail,
            },
            cssClass: 'modal2-wrapper-450-450',
            backdropDismiss: false,
        });

        //
        await modal.present();
        let response: any;
        // return the promise from onDidDismiss()
        await modal.onDidDismiss().then((verified: OverlayEventDetail) => {
            response = verified.data;
        });
        return response;
    }

    public dismiss() {
        this.modalController.dismiss();
    }

    public async toast(message: string, type?: string) {
        const toast = await this.toastController.create({
            position: 'top',
            message,
            duration: 10000,
            color: type ? 'success' : null,
        });
        toast.present();
    }
}
